import { fetchUtils, GET_LIST, GET_MANY, GET_MANY_REFERENCE } from "react-admin";

const initCustomerUsersProvider = (
  apiUrl,
  httpClient = fetchUtils.fetchJson,
  defaultCrudHandler
) => {
  return (type, resource, params) => {
    switch (type) {
      case GET_LIST:
      case GET_MANY:
      case GET_MANY_REFERENCE:
        return defaultCrudHandler(type, resource, params);
      default:
        return defaultCrudHandler(type, resource, params);
    }
  };
};

export default initCustomerUsersProvider;
